import { useQuery } from "@tanstack/react-query";
import { useUser } from "./useAuthCompat";
import { useApi } from "./useApi";

export function useMe() {
  const { isSignedIn } = useUser();
  const api = useApi();
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get("/me")).data,
    enabled: !!isSignedIn,
    staleTime: 60_000,
  });
}
